import React, { Component } from 'react';
import ImageBW from '../../components/ImageBoundsWrapper';
import CopySelector from 'shared/utils/copySelector';

export default class AdBlocker extends Component {
  headerHeight = '3.7rem';
  _style = {
    header: {
      width: '100%',
      height: this.headerHeight,
    },
    headerImage: {
      height: this.headerHeight,
      width: '100%',
      objectFit: 'contain',
      zIndex: 11,
      position: 'absolute',
      top: 0,
      left: 0,
    },
  };

  static get AsModalProps() {
    return {
      dialogClassName: 'gtp-modal-adblocker',
    };
  }

  render() {
    const description = CopySelector.getCopy(CopySelector.COPY_TYPES.ADBLOCK_DESCRIPTION)
    const title = CopySelector.getCopy(CopySelector.COPY_TYPES.ADBLOCK_TITLE)
    return (
      <>
        <div className='adBlocker-header' style={this._style.header}>
          <ImageBW
            source={require(asset`Full_Modal_Header.png`)}
            ibw={require(asset`Full_Modal_Header.ibw`)}
            style={this._style.headerImage}
          >
            <div className="header-content">
            <div style={{ width: '2rem' }} />
              <span
                className='adBlocker-title'
                data-label={title}
              >
                {title}
              </span>
              <div style={{width: '2em'}}></div>
            </div>
          </ImageBW>
        </div>
        <div className='adBlocker-container'>
          {description.map(element => (
            <p>{element}</p>
          ))}
        </div>
      </>
    );
  }
}